import { iconExternal, regularWhite } from '@ui-components/design-tokens';
import { playFontIcon } from '@ui-components/typography/helpers';
import { playFocus, VisuallyHidden } from '@ui-components/utils.styles';
import styled from 'styled-components';

export const StyledExternalIcon = styled.span`
    &:before {
        ${playFontIcon(1.2)}
        font-size: 1.2em;
        margin-right: 0.2em;
        content: '${iconExternal}';
    }
`;

export const StyledExternalLink = styled.a`
    color: ${regularWhite};
    text-decoration: none;
    ${playFocus()};
    display: inline-flex;
`;

export const HiddenA11yText = styled.span`
    ${VisuallyHidden}
`;

export const ExternalText = styled.span`
    text-decoration: underline;
`;
